<template>
    <div>
        <InputRadio
                v-model:inputValue="profileModel.title"
                :inputLbl="lbl.register.prefix"
                :itemList="lbl.register.prefix_list"
                :errorInfo="errorInfo[0]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                @update:inputValue="onFormChange()"
        ></InputRadio>
        <div class="grid grid-cols-2 gap-y-0 gap-x-3 usm:gap-x-8 ">
            <InputText
                    v-model:inputValue="profileModel.firstName"
                    :maxLength="30"
                    :isTextOnly="true"
                    :errorInfo="errorInfo[1]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.firstname"
                    @update:inputValue="onFormChange()"
            ></InputText>
            <InputText
                    v-model:inputValue="profileModel.lastName"
                    :maxLength="30"
                    :isTextOnly="true"
                    :errorInfo="errorInfo[2]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.lastname"
                    @update:inputValue="onFormChange()"
            ></InputText>
            <InputContactNumber
                    v-model:inputValue="profileModel.contactNumber"
                    :maxLength="12"
                    :minLength="12"
                    delimeter="-"
                    :errorInfo="errorInfo[3]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    :inputLbl="lbl.register.contactNumber"
                    @update:inputValue="onFormChange()"
            ></InputContactNumber>
            
            <InputCalendar v-if="isEditBirthDate"
                    v-model:inputValue="profileModel.birthDate"
                    :upperLimit="new Date()"
                    dateFormat="dd MMM yyyy"
                    :inputLbl="lbl.register.birthdate"
                    :errorInfo="errorInfo[4]"
                    :isShowError="false"
                    :isSubmitted="isSubmitted"
                    @update:inputValue="onFormChange()"
            ></InputCalendar>
            <BoxStatic :label="lbl.register.birthdate.name" v-else>
                {{FilterDateFormatShort2(profileModel.birthDate)}}
            </BoxStatic>
        </div>
        <div>
            <BoxStatic :label="lbl.register.email.name">
                {{profileModel.email}}
            </BoxStatic>
        </div>
    </div>
</template>
<script>
import { FormHelper } from '@/helper/FormHelper';
import Util from '@/helper/Utility.js';
import DatetimeHelper from '@/helper/DatetimeHelper.js';
//component
import InputRadio from '@/components/Input/label/InputRadio.vue'
import InputText from '@/components/Input/label/InputText.vue';
import InputContactNumber from '@/components/Input/label/InputContactNumber.vue';
import BoxStatic from './component/BoxStatic.vue';
import InputCalendar from '@/components/Input/label/InputCalendar.vue'
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//service
import { RegisterFormInit } from '@/module/Register/model/RegisterModel.js';
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA.js';

export default {
    mixins: [LocaleMixin, ModalMixin],
    components: {
        InputRadio,
        InputText,
        InputContactNumber,
        BoxStatic,
        InputCalendar
    },
    props: {
        profile: { type: Object, required: true },
    },
    data: function () {
        return {
            profileModel: null,
            prefixList: RegisterFormInit.genPrefix(),
            errorInfo: FormHelper.genErrorInfo(5),
            isSubmitted: false,

            pdpaVersion: {
                terms: 1,
                privacy: 1,
                marketing: 1,
            },
            isEditBirthDate: true,
        };
    },
    created: function () {
        this.profileModel = this.profile;
        if (this.profileModel.birthDate) {
            this.isEditBirthDate = false;
        }
        // this.getPdpaVersion();
    },
    methods: {
        getPdpaVersion: function () {
            BzbsPDPA.apiGetPDPAVersion().subscribe({
                next: (data) => {
                    console.log('pdap version', data);
                    this.pdpaVersion.terms = data.terms.current_version;
                    this.pdpaVersion.privacy = data.privacy.current_version;
                    this.pdpaVersion.marketing = data.marketingOption.current_version;
                },
                error: (err) => {
                    this.errorApi(err);
                },
            });
        },

        validateForm: function () {
            Util.log(this.errorInfo);
            let rs = FormHelper.validate(this.errorInfo);

            if (rs) {
                // check time
                let currentDate = new Date();
                let dateCheck = DatetimeHelper.compareYear(this.profileModel.birthDate, currentDate, 10);
                // console.log('date check', dateCheck);

                if (dateCheck > 0) {
                    this.errorInfo[4].setValid(false);
                    this.errorInfo[4].setMsg('อายุไม่ถึง');
                    rs = false;
                }
            }

            return {
                rs: rs,
                error: FormHelper.getFirstErrorItem(this.errorInfo),
            };
        },
        getFormValue: function () {
            return this.profileModel;
        },

        onFormChange: function () {
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
